import { render } from "./HowWeWorkSection.vue?vue&type=template&id=d96371e0&scoped=true"
import script from "./HowWeWorkSection.vue?vue&type=script&lang=js"
export * from "./HowWeWorkSection.vue?vue&type=script&lang=js"

import "./HowWeWorkSection.vue?vue&type=style&index=0&id=d96371e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96371e0"]])

export default __exports__